// src/components/CirculationRules.js
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Button, ProTableOt, Row, Col, Form, message, Alert, useCRUDController, Switch, Divider, Input, Select } from "../../../ui/ot";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../../ui/card"
import { AlertCircle } from "lucide-react"

import moment from "moment";
import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLibrary } from "../../controllers/LibraryController";
import { useCirculationRules } from "../../controllers/CirculationRulesController";
import CirculationRulesModal, { CirculationRulesP1Form, CirculationRulesP2Form, CirculationRulesP3Form, CirculationRulesP4Form, CirculationRulesP5Form, CirculationRulesP6Form } from '../../components/CirculationRulesModal';
import dayjs from 'dayjs';


const CirculationRules = ({
	fieldName,
	hasValue = false,
	propsRowKey = "key",
	keyPrefix = "library.backstage.Circulation.Rules",
	defaultSelectedRowsInfo = [],
	defaultSelectedRowsKeys = [],
    propsForm,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsOnValuesChange = () => { }, 
	propsOnFinish = () => { }, 
	permission_level = null, 
}) => {
	const { t } = useTranslation("translation", { keyPrefix: keyPrefix });
	const [form_] = Form.useForm();
	const form = propsForm ?? form_;
	const actionRef1 = useRef()
	const actionRef2 = useRef()
	const actionRef3 = useRef()
	const actionRef4 = useRef()
	const actionRef5 = useRef()
	const actionRef6 = useRef()

	const [clone_rules_data, set_clone_rules_data] = useState({})

	const columns1 = [
		{
			title: t("patron_category"),
			dataIndex: "categorycode",
			key: "categorycode",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "categorycode") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							if (record["type_data"][i]["options"][j]["value"] === record?.categorycode) {
								render_text = record["type_data"][i]["options"][j]["text"]
							}
						}
					}
				}
				return (<>{record?.categorycode ? render_text : "All"}</>)
			},
		},
		{
			title: t("item_type"),
			dataIndex: "itemtype",
			key: "itemtype",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "itemtype") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							if (record["type_data"][i]["options"][j]["value"] === record?.itemtype) {
								render_text = record["type_data"][i]["options"][j]["text"]
							}
						}
					}
				}
				return (<>{record?.itemtype ? render_text : "All"}</>)
			},
		},
		// {
		// 	title: t("note"),
		// 	dataIndex: "note",
		// 	// key: "note",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "note") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("current_checkouts_allowed"),
			dataIndex: "maxissueqty",
			key: "maxissueqty",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "maxissueqty") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		// {
		// 	title: t("current_on_site_checkouts_allowed"),
		// 	dataIndex: "maxonsiteissueqty",
		// 	key: "maxonsiteissueqty",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "maxonsiteissueqty") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("loan_period"),
			dataIndex: "issuelength",
			key: "issuelength",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "issuelength") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("days_mode"),
			dataIndex: "daysmode",
			key: "daysmode",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "daysmode") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("unit"),
			dataIndex: "lengthunit",
			key: "lengthunit", render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "lengthunit") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("hard_due_date"),
			dataIndex: "hardduedate",
			key: "hardduedate",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "hardduedatecompare") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				let render_date_text = record?.rules.map(item => {
					if (item?.rule_name === "hardduedate") return item?.rule_value
				})
				return (<><Row><Col span={24}>{render_text}</Col><Col span={24}>{render_date_text}</Col></Row></>)
			},
		},
		// {
		// 	title: t("decreased_loan_period_for_high_holds"),
		// 	dataIndex: "decreaseloanholds",
		// 	key: "decreaseloanholds",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "decreaseloanholds") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("fine_amount"),
			dataIndex: "fine",
			key: "fine",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "fine") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		// {
		// 	title: t("fine_charging_interval"),
		// 	dataIndex: "chargeperiod",
		// 	key: "chargeperiod",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "chargeperiod") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("when_to_charge"),
			dataIndex: "chargeperiod_charge_at",
			key: "chargeperiod_charge_at",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "chargeperiod_charge_at") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("fine_suspension_grace_period"),
			dataIndex: "firstremind",
			key: "firstremind",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "firstremind") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		// {
		// 	title: t("overdue_fines_cap"),
		// 	dataIndex: "overduefinescap",
		// 	key: "overduefinescap",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "overduefinescap") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		// {
		// 	title: t("cap_fine_at_replacement_price"),
		// 	dataIndex: "cap_fine_to_replacement_price",
		// 	key: "cap_fine_to_replacement_price",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "cap_fine_to_replacement_price") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		// {
		// 	title: t("suspension_in_days"),
		// 	dataIndex: "finedays",
		// 	key: "finedays",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "finedays") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		// {
		// 	title: t("max_suspension_duration"),
		// 	dataIndex: "maxsuspensiondays",
		// 	key: "maxsuspensiondays",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "maxsuspensiondays") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("suspension_charging_interval"),
			dataIndex: "suspension_chargeperiod",
			key: "suspension_chargeperiod",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "suspension_chargeperiod") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("renewals_allowed"),
			dataIndex: "renewalsallowed",
			key: "renewalsallowed",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "renewalsallowed") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("renewal_period"),
			dataIndex: "renewalperiod",
			key: "renewalperiod",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "renewalperiod") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("no_renewal_before"),
			dataIndex: "norenewalbefore",
			key: "norenewalbefore",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "norenewalbefore") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		// {
		// 	title: t("no_automatic_renewal_before"),
		// 	dataIndex: "noautorenewalbefore",
		// 	key: "noautorenewalbefore",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "noautorenewalbefore") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("automatic_renewal"),
			dataIndex: "auto_renew",
			key: "auto_renew",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "auto_renew") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		// {
		// 	title: t("no_automatic_renewal_after"),
		// 	dataIndex: "no_auto_renewal_after",
		// 	key: "no_auto_renewal_after",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "no_auto_renewal_after") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		// {
		// 	title: t("no_automatic_renewal_after_hard_limit"),
		// 	dataIndex: "no_auto_renewal_after_hard_limit",
		// 	key: "no_auto_renewal_after_hard_limit",
		// 	render: (text, record) => {
		// 		let render_text = record?.rules.map(item => {
		// 			if(item?.rule_name === "no_auto_renewal_after_hard_limit") return item?.rule_value
		// 		})
		// 		return (<>{render_text}</>)
		// 	},
		// },
		{
			title: t("holds_allowed_total"),
			dataIndex: "reservesallowed",
			key: "reservesallowed",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "reservesallowed") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("holds_allowed_daily"),
			dataIndex: "holds_per_day",
			key: "holds_per_day",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "holds_per_day") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("holds_per_record"),
			dataIndex: "holds_per_record",
			key: "holds_per_record",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "holds_per_record") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("onself_holds_allowed"),
			dataIndex: "onshelfholds",
			key: "onshelfholds",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "onshelfholds") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("opac_item_level_holds"),
			dataIndex: "opacitemholds",
			key: "opacitemholds",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "opacitemholds") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("holds_pick_up_period"),
			dataIndex: "holds_pickup_period",
			key: "holds_pickup_period",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "holds_pickup_period") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("rental_discount"),
			dataIndex: "rentaldiscount",
			key: "rentaldiscount",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "rentaldiscount") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
	];
	const columns2 = [
		{
			title: t("total_current_checkouts_allowed"),
			dataIndex: "patron_maxissueqty",
			key: "patron_maxissueqty",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "patron_maxissueqty") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("total_current_on_site_checkouts_allowed"),
			dataIndex: "patron_maxonsiteissueqty",
			key: "patron_maxonsiteissueqty",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "patron_maxonsiteissueqty") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("maximum_total_holds_allowed_count"),
			dataIndex: "max_holds",
			key: "max_holds",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "max_holds") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("hold_policy"),
			dataIndex: "holdallowed",
			key: "holdallowed",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "holdallowed") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("hold_pickup_library_match"),
			dataIndex: "hold_fulfillment_policy",
			key: "hold_fulfillment_policy",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "hold_fulfillment_policy") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("return_policy"),
			dataIndex: "returnbranch",
			key: "returnbranch",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "returnbranch") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
	];
	const columns3 = [
		{
			title: t("patron_category"),
			dataIndex: "categorycode",
			key: "categorycode",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "categorycode") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							if (record["type_data"][i]["options"][j]["value"] === record?.categorycode) {
								render_text = record["type_data"][i]["options"][j]["text"]
							}
						}
					}
				}
				return (<>{record?.categorycode ? render_text : "All"}</>)
			},
		},
		{
			title: t("total_current_checkouts_allowed"),
			dataIndex: "patron_maxissueqty",
			key: "patron_maxissueqty",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "patron_maxissueqty") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("total_current_on_site_checkouts_allowed"),
			dataIndex: "patron_maxonsiteissueqty",
			key: "patron_maxonsiteissueqty",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "patron_maxonsiteissueqty") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("total_holds_allowed"),
			dataIndex: "max_holds",
			key: "max_holds",
			render: (text, record) => {
				let render_text = record?.rules.map(item => {
					if (item?.rule_name === "max_holds") return item?.rule_value
				})
				return (<>{render_text}</>)
			},
		},
	];
	const columns4 = [
		{
			title: t("patron_category"),
			dataIndex: "categorycode",
			key: "categorycode",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "categorycode") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							if (record["type_data"][i]["options"][j]["value"] === record?.categorycode) {
								render_text = record["type_data"][i]["options"][j]["text"]
							}
						}
					}
				}
				return (<>{record?.categorycode ? render_text : "All"}</>)
			},
		},
		{
			title: t("item_type"),
			dataIndex: "itemtype",
			key: "itemtype",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "itemtype") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							if (record["type_data"][i]["options"][j]["value"] === record?.itemtype) {
								render_text = record["type_data"][i]["options"][j]["text"]
							}
						}
					}
				}
				return (<>{record?.itemtype ? render_text : "All"}</>)
			},
		},
		{
			title: t("cancellation_allowed"),
			dataIndex: "waiting_hold_cancellation",
			key: "waiting_hold_cancellation",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "waiting_hold_cancellation") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
	];
	const columns5 = [
		{
			title: t("refund_lost_item_replacement_fee"),
			dataIndex: "lostreturn",
			key: "lostreturn",
			render: (text, record) => {
				// let render_text = record?.rules.map(item => {
				// 	if(item?.rule_name === "lostreturn") return item?.rule_value
				// })
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "lostreturn") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("refund_lost_item_processing_fee"),
			dataIndex: "processingreturn",
			key: "processingreturn",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "processingreturn") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
	];
	const columns6 = [
		{
			title: t("item_type"),
			dataIndex: "itemtype",
			key: "itemtype",
			render: (text, record) => {
				let render_text = record?.type_data.map(item => {
					if (item?.rule_name === "itemtype") {
						return item?.options?.map((option_item) => {
							if (option_item.rule_name === record?.itemtype) {
								return option_item?.text
							}
						})
					}
				})
				return (<>{render_text}</>)
			},
		},
		{
			title: t("hold_policy"),
			dataIndex: "holdallowed",
			key: "holdallowed",
			render: (text, record) => {
				// let render_text = record?.rules.map(item => {
				// 	if(item?.rule_name === "holdallowed") return item?.rule_value
				// })
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "holdallowed") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("hold_pickup_library_match"),
			dataIndex: "hold_fulfillment_policy",
			key: "hold_fulfillment_policy",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "hold_fulfillment_policy") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
		{
			title: t("return_policy"),
			dataIndex: "returnbranch",
			key: "returnbranch",
			render: (text, record) => {
				let render_text = ""
				for (let i = 0; i < record?.type_data.length; i++) {
					if (record["type_data"][i]["rule_name"] === "returnbranch") {
						for (let j = 0; j < record["type_data"][i]["options"].length; j++) {
							for (let z = 0; z < record?.rules.length; z++) {
								if (record["type_data"][i]["rule_name"] === record["rules"][z]["rule_name"] && record["type_data"][i]["options"][j]["value"] === record["rules"][z]["rule_value"]) {
									render_text = record["type_data"][i]["options"][j]["text"]
								}
							}
						}
					}
				}
				return (<>{render_text}</>)
			},
		},
	];

	const [modalLoading, setModalLoading] = useState(false)
	// const [select_a_library, set_select_a_library] = useState("")
	const select_a_library = useRef("");
	const [clone_rules_to, set_clone_rules_to] = useState("")
	const [current_rule, set_current_rule] = useState("P1")
	const [current_rule_data, set_current_rule_data] = useState({})

	const [loading, setLoading] = useState(false)
	const [modalOpenP1, setModalOpenP1] = useState(false)
	const [modalOpenP2, setModalOpenP2] = useState(false)
	const [modalOpenP3, setModalOpenP3] = useState(false)
	const [modalOpenP4, setModalOpenP4] = useState(false)
	const [modalOpenP5, setModalOpenP5] = useState(false)
	const [modalOpenP6, setModalOpenP6] = useState(false)
	const [extra_columns, set_extra_columns] = useState([]);
	const [selectedRowKeys1, setSelectedRowKeys1] = useState(defaultSelectedRowsKeys)
	const [selectedRowKeys2, setSelectedRowKeys2] = useState(defaultSelectedRowsKeys)
	const [selectedRowKeys3, setSelectedRowKeys3] = useState(defaultSelectedRowsKeys)
	const [selectedRowKeys4, setSelectedRowKeys4] = useState(defaultSelectedRowsKeys)
	const [selectedRowKeys5, setSelectedRowKeys5] = useState(defaultSelectedRowsKeys)
	const [selectedRowKeys6, setSelectedRowKeys6] = useState(defaultSelectedRowsKeys)
	const [selectedRowsInfo1, setSelectedRowsInfo1] = useState(defaultSelectedRowsInfo)
	const [selectedRowsInfo2, setSelectedRowsInfo2] = useState(defaultSelectedRowsInfo)
	const [selectedRowsInfo3, setSelectedRowsInfo3] = useState(defaultSelectedRowsInfo)
	const [selectedRowsInfo4, setSelectedRowsInfo4] = useState(defaultSelectedRowsInfo)
	const [selectedRowsInfo5, setSelectedRowsInfo5] = useState(defaultSelectedRowsInfo)
	const [selectedRowsInfo6, setSelectedRowsInfo6] = useState(defaultSelectedRowsInfo)
	const [overdueDays, setOverdueDays] = useState({
		"grace_period_id": null,
		"days": 0,
	})
	const [isSaving, setIsSaving] = useState(false)
	const [isSuspensionSettingSaving, setIsSuspensionSettingSaving] = useState(false)
	const [suspensionSetting, setSuspensionSetting] = useState({
		"days": 0,
		"rule_switch": 0
	})
	const [suspensionDuration, setSuspensionDuration] = useState("14")
	const rowSelection1 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys1]
			selectRow = [...selectedRowsInfo1]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys1(select_temp)
			setSelectedRowsInfo1(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys1]
			selectRow = [...selectedRowsInfo1]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys1(select_temp)
			setSelectedRowsInfo1(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const rowSelection2 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys2]
			selectRow = [...selectedRowsInfo2]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys2(select_temp)
			setSelectedRowsInfo2(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys2]
			selectRow = [...selectedRowsInfo2]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys2(select_temp)
			setSelectedRowsInfo2(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const rowSelection3 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys3]
			selectRow = [...selectedRowsInfo3]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys3(select_temp)
			setSelectedRowsInfo3(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys3]
			selectRow = [...selectedRowsInfo3]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys3(select_temp)
			setSelectedRowsInfo3(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const rowSelection4 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys4]
			selectRow = [...selectedRowsInfo4]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys4(select_temp)
			setSelectedRowsInfo4(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys4]
			selectRow = [...selectedRowsInfo4]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys4(select_temp)
			setSelectedRowsInfo4(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const rowSelection5 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys5]
			selectRow = [...selectedRowsInfo5]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys5(select_temp)
			setSelectedRowsInfo5(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys5]
			selectRow = [...selectedRowsInfo5]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys5(select_temp)
			setSelectedRowsInfo5(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const rowSelection6 = {
		//不一定都是對id
		onSelectAll: (selected, selectedRows, changeRows) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys6]
			selectRow = [...selectedRowsInfo6]

			if (selected) {
				changeRows.map((value, key) => {
					select_temp.push(value?.[propsRowKey])
					selectRow.push(value)
				})

			}
			else {
				changeRows.map((value, key) => {
					const index = select_temp.indexOf(value?.[propsRowKey]);
					select_temp.splice(index, 1);
					selectRow.splice(index, 1);

				})
			}
			setSelectedRowKeys6(select_temp)
			setSelectedRowsInfo6(selectRow)

		},
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			let select_temp = []
			let selectRow = []
			select_temp = [...selectedRowKeys6]
			selectRow = [...selectedRowsInfo6]

			if (selected) {
				select_temp.push(record?.[propsRowKey])
				selectRow.push(record)
			}
			else {
				select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
				selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
			}
			setSelectedRowKeys6(select_temp)
			setSelectedRowsInfo6(selectRow)

		},
		getCheckboxProps: (record) => ({
			// disabled: record.pass === null,
		}),
	};
	const { check1, setCheck1, checkAll1, setOrders1, custom_filter_key1 } = useTableColumnsCheck1(columns1);
	const { check2, setCheck2, checkAll2, setOrders2, custom_filter_key2 } = useTableColumnsCheck2(columns2);
	const { check3, setCheck3, checkAll3, setOrders3, custom_filter_key3 } = useTableColumnsCheck3(columns3);
	const { check4, setCheck4, checkAll4, setOrders4, custom_filter_key4 } = useTableColumnsCheck4(columns4);
	const { check5, setCheck5, checkAll5, setOrders5, custom_filter_key5 } = useTableColumnsCheck5(columns5);
	const { check6, setCheck6, checkAll6, setOrders6, custom_filter_key6 } = useTableColumnsCheck6(columns6);
	const setParamsFilter = (obj) => {
		return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
	}

	const onValuesChange = (e, { name, ...props }) => {
		let formValues = null
		if (fieldName) {
			if (propsForm) {
				formValues = propsForm.getFieldValue(fieldName)
			}
			else {
				formValues = form.getFieldValue(fieldName)
			}
		} else {
			if (propsForm) {
				formValues = propsForm.getFieldsValue()
			}
			else {
				formValues = form.getFieldsValue()
			}
		}
		set_clone_rules_data(formValues)
		propsOnValuesChange({
			...formValues,
		})
	}
	const onFinish = (value) => {
	}
	const checkinGracePeriodReload = () => {
		checkinGracePeriodController.getData({})
			.then((response) => {
				let data = response?.data || []
				let firstData = data?.find((e) => true)
				setOverdueDays(firstData)
			})
			.finally(() => { })
	}
	const suspensionSettingReload = () => {
		suspensionSettingController.getData({})
			.then((response) => {
				let data = response?.data || []
				let firstData = data?.find((e) => true)
				setSuspensionSetting(firstData)
			})
			.finally(() => { })
	}
	const onCirculationRulesFinish = ({ axiosMode, status, values }) => {
		propsOnFinish({ axiosMode, status, values })
		let array = {
			P1: actionRef1,
			P2: actionRef2,
			P3: actionRef3,
			P4: actionRef4,
			P5: actionRef5,
			P6: actionRef6,
		}
		if (status === "success") {
			if (axiosMode === "post") {
				message.success("新增成功")
				array[values?.current_rule].current.reloadAndRest();
				setSelectedRowKeys1([])
				setSelectedRowKeys2([])
				setSelectedRowKeys3([])
				setSelectedRowKeys4([])
				setSelectedRowKeys5([])
				setSelectedRowKeys6([])
				setSelectedRowsInfo1([])
				setSelectedRowsInfo2([])
				setSelectedRowsInfo3([])
				setSelectedRowsInfo4([])
				setSelectedRowsInfo5([])
				setSelectedRowsInfo6([])
			}
			else if (axiosMode === "patch") {
				message.success("修改成功")
				array[values?.current_rule].current.reload();
				setSelectedRowKeys1([])
				setSelectedRowKeys2([])
				setSelectedRowKeys3([])
				setSelectedRowKeys4([])
				setSelectedRowKeys5([])
				setSelectedRowKeys6([])
				setSelectedRowsInfo1([])
				setSelectedRowsInfo2([])
				setSelectedRowsInfo3([])
				setSelectedRowsInfo4([])
				setSelectedRowsInfo5([])
				setSelectedRowsInfo6([])
			}
			else if (axiosMode === "delete") {
				message.success("刪除成功")
				array[values?.current_rule].current.reloadAndRest();
				setSelectedRowKeys1([])
				setSelectedRowKeys2([])
				setSelectedRowKeys3([])
				setSelectedRowKeys4([])
				setSelectedRowKeys5([])
				setSelectedRowKeys6([])
				setSelectedRowsInfo1([])
				setSelectedRowsInfo2([])
				setSelectedRowsInfo3([])
				setSelectedRowsInfo4([])
				setSelectedRowsInfo5([])
				setSelectedRowsInfo6([])

			}
			if (axiosMode !== "get") {
				setModalLoading(false)
				if (values?.current_rule === "P1") {
					setModalOpenP1(false)
				}
				else if (values?.current_rule === "P2") {
					setModalOpenP2(false)
				}
				else if (values?.current_rule === "P3") {
					setModalOpenP3(false)
				}
				else if (values?.current_rule === "P4") {
					setModalOpenP4(false)
				}
				else if (values?.current_rule === "P5") {
					setModalOpenP5(false)
				}
				else if (values?.current_rule === "P6") {
					setModalOpenP6(false)
				}
			}
		}
		else if (status === "error") {
			if (axiosMode === "post") {
				message.error("新增失敗")
				// actionRef.current.reloadAndRest();
			}
			else if (axiosMode === "patch") {
				message.error("修改失敗")
				// actionRef.current.reloadAndRest();
			}
			else if (axiosMode === "delete") {
				message.error("刪除失敗")
				// actionRef.current.reloadAndRest();
			}
			// setModalLoading(false)
			// setModalOpen(false)
		}
	}

	const onCheckinGracePeriodFinish = ({ axiosMode, status, values }) => {
		if (status === "success") {
			if (axiosMode === "post") {
				message.success("新增成功")
			}
			else if (axiosMode === "patch") {
				message.success("逾期設定修改成功")
			}
			else if (axiosMode === "delete") {
			}
		}
		else if (status === "error") {
			if (axiosMode === "post") {
				message.error("新增失敗")
			}
			else if (axiosMode === "patch") {
				message.error("修改失敗")
			}
			else if (axiosMode === "delete") {
				message.error("刪除失敗")
			}
		}
		if (axiosMode !== "get") {
			checkinGracePeriodReload()
			setIsSaving(false)
		}
	}
	const onSuspensionSettingFinish = ({ axiosMode, status, values }) => {
		if (status === "success") {
			if (axiosMode === "post") {
				message.success("新增成功")
			}
			else if (axiosMode === "patch") {
				message.success("停權設定修改成功")
			}
			else if (axiosMode === "delete") {
			}
		}
		else if (status === "error") {
			if (axiosMode === "post") {
				message.error("新增失敗")
			}
			else if (axiosMode === "patch") {
				message.error("修改失敗")
			}
			else if (axiosMode === "delete") {
				message.error("刪除失敗")
			}
		}
		if (axiosMode !== "get") {
			suspensionSettingReload()
			setIsSuspensionSettingSaving(false)

		}
	}
	const {
		LibraryData,
		getLibraryData
	} = useLibrary({
		onBefore: () => { },
		onLibrary: () => { },
	})

	const {
		CirculationRulesTypeData,
		CirculationRulesData,
		getCirculationRulesTypeData,
		getCirculationRulesP1Data,
		postCirculationRulesP1Data,
		patchCirculationRulesP1Data,
		deleteCirculationRulesP1Data,
		getCirculationRulesP2Data,
		postCirculationRulesP2Data,
		patchCirculationRulesP2Data,
		deleteCirculationRulesP2Data,
		getCirculationRulesP3Data,
		postCirculationRulesP3Data,
		patchCirculationRulesP3Data,
		deleteCirculationRulesP3Data,
		getCirculationRulesP4Data,
		postCirculationRulesP4Data,
		patchCirculationRulesP4Data,
		deleteCirculationRulesP4Data,
		getCirculationRulesP5Data,
		postCirculationRulesP5Data,
		patchCirculationRulesP5Data,
		getCirculationRulesP6Data,
		postCirculationRulesP6Data,
		patchCirculationRulesP6Data,
		deleteCirculationRulesP6Data,
		getCirculationRulesData,
		postCirculationRulesData,
		patchCirculationRulesData,
		deleteCirculationRulesData,
		postCirculationRulesClone,
	} = useCirculationRules({
		onBefore: () => { },
		onFinish: onCirculationRulesFinish,
	})
	const checkinGracePeriodController = useCRUDController({
		apiRoute: "/library/koha/checkin/grace_period",
		onFinish: onCheckinGracePeriodFinish,
		onBefore: () => {
		}
	})
	const suspensionSettingController = useCRUDController({
		apiRoute: "/library/koha/circulation_rules/suspension_setting",
		onFinish: onSuspensionSettingFinish,
		onBefore: () => {
		}
	})


	useEffect(() => {
		// getLibraryData()
		getCirculationRulesData()
		getCirculationRulesTypeData()
		checkinGracePeriodReload()
		suspensionSettingReload()
	}, [])


	return (
		<Row gutter={[4, 4]}>
			<Col span={24}>
				<Row gutter={[16, 16]}>
					<Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
						<Title>{t("defining_circulation_and_fine_rules")}</Title>
						<Row gutter={[8, 8]} style={{ backgroundColor: '#AFD3E2' }}>
							<Col span={24}><Label>{t("rules_application_order")}</Label></Col>
							<Col span={24}>
								<ul style={{ listStyleType: "disc", listStylePosition: "inside" }}>
									<li>{t("same_library_same_patron_same_item")}</li>
									<li>{t("same_library_same_patron_all_items")}</li>
									<li>{t("same_library_all_patrons_same_item")}</li>
									<li>{t("same_library_all_patrons_all_items")}</li>
									<li>{t("default_same_patron_same_item")}</li>
									<li>{t("default_same_patron_all_items")}</li>
									<li>{t("default_all_patrons_same_item")}</li>
									<li>{t("default_all_patrons_all_items")}</li>
								</ul>
							</Col>
							<Col span={24}><Label>{t("parent_child_rule_note")}</Label></Col>
							<Col span={24}><Label>{t("modify_rule_instruction")}</Label></Col>
						</Row>
					</Col>
					<Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
						<Card className="max-w-md border-0 ">
							<CardHeader>
								<CardTitle>逾期停權設定</CardTitle>
								<CardDescription>設定使用者逾期多少天後自動停權</CardDescription>
							</CardHeader>
							<CardContent className="space-y-4">
								<div className="space-y-1">
									<Label htmlFor="overdue-days">逾期天數</Label>
									<div className="flex items-center gap-2">
										<Input
											type="number"
											min="0"
											value={overdueDays?.days}
											onChange={(e) => setOverdueDays((pre) => {
												return {
													...pre,
													days: e.target.value
												}
											})}
											className="w-24"
										/>
										<span>天</span>
									</div>
									<p className="text-sm text-muted-foreground">使用者逾期超過指定天數後，系統將自動停權該帳戶</p>
								</div>
								<Divider />
								<div className="space-y-1">
									<div className="flex items-center justify-between">
										<Label htmlFor="cumulative-days" className="font-medium">
											停權天數累加計算
										</Label>
										<Switch
											checkedChildren={"開啟"}
											unCheckedChildren={"關閉"}
											mode="number"
											value={parseInt(suspensionSetting?.rule_switch)}
											onChange={(e) => {
												console.log({
													e: e.target.value
												})
												setSuspensionSetting((pre) => {
													return {
														...pre,
														rule_switch: e.target.value
													}
												})
											}}
										/>
									</div>
									<p className="text-sm text-muted-foreground">
										{parseInt(suspensionSetting?.rule_switch) === 1
											? "開啟後，多個逾期項目的天數將會累加計算（例如：有3個逾期項目將會以最晚逾期的日期開始進行累加，若每本為10天，則累計停權30天）"
											: "關閉時，僅計算最長的單一逾期天數（例如：有3個逾期項目，將會以最晚逾期的日期開始進行，若每本為10天，則停權10天）"}
									</p>
								</div>
								<div className="space-y-1">
									<Label htmlFor="suspension-duration">停權天數</Label>
									<div className="flex items-center gap-2">
										<Input
											id="suspension-duration"
											type="number"
											min="1"
											value={suspensionSetting?.days}
											onChange={(e) => {
												setSuspensionSetting((pre) => {
													return {
														...pre,
														days: e.target.value
													}
												})
											}}
											className="w-24"
										/>
										<span>天</span>
									</div>
									<p className="text-sm text-muted-foreground">
										設定每次停權的持續天數，停權期滿後系統將自動恢復使用者權限
									</p>
								</div>
							</CardContent>
							<CardFooter>
								<Button
									onClick={() => {
										setIsSaving(true)
										setIsSuspensionSettingSaving(true)
										if (overdueDays?.grace_period_id) {
											checkinGracePeriodController.patchData([{
												...overdueDays
											}])
										}
										else {
											checkinGracePeriodController.postData([{
												...overdueDays
											}])
										}
										if (suspensionSetting?.suspension_setting_id) {
											suspensionSettingController.patchData([{
												...suspensionSetting
											}])
										}
										else {
											suspensionSettingController.postData([{
												...suspensionSetting
											}])
										}
									}}
									disabled={isSaving || isSuspensionSettingSaving}>
									{(isSaving || isSuspensionSettingSaving) ? "儲存中..." : "儲存設定"}
								</Button>
							</CardFooter>
						</Card>
					</Col>
				</Row>

			</Col>
			<Col span={24}>
				{!loading &&
					<ProTableOt
						// showSearch={false}
						actionRef={actionRef1}
						columns={columns1}
						check={check1}
						setCheck={setCheck1}
						headerTitle={<></>}
						rowKey={propsRowKey}
						formMode={true}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders1(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key1,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
								p: "P1"
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP1Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys1,
							selectedRowsInfo: selectedRowsInfo1,
							setSelectedRowKeys: setSelectedRowKeys1,
							setSelectedRowsInfo: setSelectedRowsInfo1,
							...rowSelection1,

						}}
						modalOpen={modalOpenP1}
						setModalOpen={setModalOpenP1}
						scroll={{
							x: "100vw"
						}}
						toolBarRender={() => toolBarRender([
							<Row gutter={[8, 8]} align="middle">
								<Col  ><Label>{t("select_a_library")}：</Label></Col>
								<Col  >
									<Select
										value={select_a_library.current}
										style={{
											maxWidth: "20vw",
											minWidth: "10vw",

										}}
										options={CirculationRulesTypeData?.find(_ => true)?.rules?.find(_ => true)?.options.map(item => (
											{
												label: item?.text,
												value: item?.value,
											}
										))}
										onChange={(output) => {
											// set_select_a_library(output)
											getCirculationRulesData({ branchcode: output })
											select_a_library.current = output
											setLoading(true)
											setTimeout(() => {
												setLoading(false)
											}, 500)
										}}
									/>
								</Col>
							</Row>
						])}
						extraActionRender={(item) => {
							return (<></>)
						}}

						propsUseData={() => {
							return {
								postData: postCirculationRulesP1Data,
								patchData: patchCirculationRulesP1Data,
								deleteData: deleteCirculationRulesP1Data,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP1Form
								keyPrefix={keyPrefix}
								customFormItems={customFormItems}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef1.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch={permission_level === 1 ? true : false}
						propsPost={permission_level === 1 ? true : false}
						propsDelete={permission_level === 1 ? true : false}
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for(let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
								if(item?.rules[i].rule_name === "hardduedate") {
									if(modal_item[item?.rules[i].rule_name] === "") {
										modal_item[item?.rules[i].rule_name] = undefined
									} 
								}
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode
							modal_item["itemtype"] = item?.itemtype
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
								hardduedate: dayjs(modal_item?.hardduedate),
								no_auto_renewal_after_hard_limit: dayjs(modal_item?.no_auto_renewal_after_hard_limit)
							})
						}}
						propsWidth={1000}
					/>}
				{false && <WhiteBox>
					<Title>{t("default_checkout_hold_return_policy")}</Title>
					<Row gutter={[8, 8]} >
						<Col span={24}><Label>{t("default_max_checkouts_info")}</Label></Col>
					</Row>
					{!loading && <ProTableOt
						showSearch={false}
						columns={columns2}
						actionRef={actionRef2}
						check={check2}
						setCheck={setCheck2}
						headerTitle={<></>}
						rowKey={propsRowKey}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders2(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key2,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP2Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys2,
							selectedRowsInfo: selectedRowsInfo2,
							setSelectedRowKeys: setSelectedRowKeys2,
							setSelectedRowsInfo: setSelectedRowsInfo2,
							...rowSelection2,
						}}
						modalOpen={modalOpenP2}
						setModalOpen={setModalOpenP2}
						scroll={{
							x: "100vw"
						}}
						toolBarRender={() => toolBarRender([
						])}
						extraActionRender={(item) => {
							return (<></>)
						}}

						propsUseData={() => {
							return {
								postData: postCirculationRulesP2Data,
								patchData: patchCirculationRulesP2Data,
								deleteData: deleteCirculationRulesP2Data,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP2Form
								keyPrefix={keyPrefix}
								customFormItems={customFormItems}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef2.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch
						propsPost
						propsDelete
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for (let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode
							modal_item["itemtype"] = item?.itemtype
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
							})
						}}
						propsWidth={1000}
					/>}
				</WhiteBox>}
				{false && <WhiteBox>
					<Title>{t("default_checkout_hold_patron_category")}</Title>
					<Row gutter={[8, 8]} >
						<Col span={24}><Label>{t("library_max_loans_info")}</Label></Col>
						<Col span={24}><Label>{t("unlimited_loans_note")}</Label></Col>
					</Row>
					{!loading && <ProTableOt
						showSearch={false}
						columns={columns3}
						actionRef={actionRef3}
						check={check3}
						setCheck={setCheck3}
						headerTitle={<></>}
						rowKey={propsRowKey}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders3(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key3,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP3Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys3,
							selectedRowsInfo: selectedRowsInfo3,
							setSelectedRowKeys: setSelectedRowKeys3,
							setSelectedRowsInfo: setSelectedRowsInfo3,
							...rowSelection3,
						}}
						modalOpen={modalOpenP3}
						setModalOpen={setModalOpenP3}
						scroll={{
							x: "100vw"
						}}
						toolBarRender={() => toolBarRender([
						])}
						extraActionRender={(item) => {
							return (<></>)
						}}

						propsUseData={() => {
							return {
								postData: postCirculationRulesP3Data,
								patchData: patchCirculationRulesP3Data,
								deleteData: deleteCirculationRulesP3Data,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP3Form
								keyPrefix={keyPrefix}
								customFormItems={customFormItems}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef3.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch
						propsPost
						propsDelete
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for (let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode
							modal_item["itemtype"] = item?.itemtype
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
							})
						}}
						propsWidth={1000}
					/>}
				</WhiteBox>}
				{false && <WhiteBox>
					<Title>{t("default_waiting_hold_cancellation_policy")}</Title>
					<Row gutter={[8, 8]} >
						<Col span={24}><Label>{t("waiting_hold_cancellation_instruction")}</Label></Col>
					</Row>
					{!loading && <ProTableOt
						showSearch={false}
						columns={columns4}
						actionRef={actionRef4}
						check={check4}
						setCheck={setCheck4}
						headerTitle={<></>}
						rowKey={propsRowKey}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders4(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key4,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP4Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys4,
							selectedRowsInfo: selectedRowsInfo4,
							setSelectedRowKeys: setSelectedRowKeys4,
							setSelectedRowsInfo: setSelectedRowsInfo4,
							...rowSelection4,
						}}
						modalOpen={modalOpenP4}
						setModalOpen={setModalOpenP4}
						scroll={{
							x: "100vw"
						}}
						toolBarRender={() => toolBarRender([
						])}
						extraActionRender={(item) => {
							return (<></>)
						}}

						propsUseData={() => {
							return {
								postData: postCirculationRulesP4Data,
								patchData: patchCirculationRulesP4Data,
								deleteData: deleteCirculationRulesP4Data,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP4Form
								keyPrefix={keyPrefix}
								customFormItems={customFormItems}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef4.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch
						propsPost
						propsDelete
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for (let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode ? item?.categorycode : "*"
							modal_item["itemtype"] = item?.itemtype ? item?.itemtype : "*"
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
							})
						}}
						propsWidth={1000}
					/>}
				</WhiteBox>}
				{false && <WhiteBox>
					<Title>{t("default_lost_item_fee_refund_policy")}</Title>
					<Row gutter={[8, 8]} >
						<Col span={24}><Label>{t("lost_item_fee_instruction")}</Label></Col>
					</Row>
					{!loading && <ProTableOt
						showSearch={false}
						columns={columns5}
						actionRef={actionRef5}
						check={check5}
						setCheck={setCheck5}
						headerTitle={<></>}
						rowKey={propsRowKey}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders5(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key5,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP5Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys5,
							selectedRowsInfo: selectedRowsInfo5,
							setSelectedRowKeys: setSelectedRowKeys5,
							setSelectedRowsInfo: setSelectedRowsInfo5,
							...rowSelection5,
						}}
						modalOpen={modalOpenP5}
						setModalOpen={setModalOpenP5}
						scroll={{
							x: "100vw"
						}}
						extraActionRender={(item) => {
							return (<></>)
						}}

						propsUseData={() => {
							return {
								postData: postCirculationRulesP5Data,
								patchData: patchCirculationRulesP5Data,
								// deleteData: deleteCheckoutHistoryData,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP5Form
								keyPrefix={keyPrefix}
								customFormItems={customFormItems}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef5.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch
						propsPost
						// propsDelete
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for (let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode
							modal_item["itemtype"] = item?.itemtype
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
							})
						}}
						propsWidth={1000}
					/>}
				</WhiteBox>}
				{false && <WhiteBox>
					<Title>{t("default_holds_policy_by_item_type")}</Title>
					<Row gutter={[8, 8]} >
						<Col span={24}><Label>{t("edit_hold_policy_itemtype_info")}</Label></Col>
						<Col span={24}><Label>{t("hold_policy_effects")}</Label></Col>
						<Col span={24}>
							<ul style={{ listStyleType: "disc", listStylePosition: "inside" }}>
								<li><b>{t("from_any_library")}</b>{t("from_any_library_details")}</li>
								<li><b>{t("from_local_hold_group")}</b>{t("from_local_hold_group_details")}</li>
								<li><b>{t("from_home_library")}</b>{t("from_home_library_details")}</li>
								<li><b>{t("no_holds_allowed")}</b>{t("no_holds_allowed_details")}</li>
							</ul>
						</Col>
						<Col span={24}><Label><b>{t("hold_policy_override_note")}</b>{t("hold_policy_override_details")}</Label></Col>
						<Col span={24}><Label><b>{t("important_info")}</b></Label></Col>
						<Col span={24}>
							<ul style={{ listStyleType: "disc", listStylePosition: "inside" }}>
								<li>{t("reserves_control_branch_info")}</li>
								<li>{t("circ_control_returns_branch_info")}</li>
								<li>{t("item_floats_policy_note")}</li>
							</ul>
						</Col>
					</Row>
					{!loading && <ProTableOt
						showSearch={false}
						columns={columns6}
						actionRef={actionRef6}
						check={check5}
						setCheck={setCheck6}
						headerTitle={<></>}
						rowKey={propsRowKey}
						request={async (params = {}, sort, filter) => {
							let newParams = {
							};
							let order = setOrders6(sort)
							newParams = {
								// ...params, //只有這個範例要有，其他請看你的後端要什麼資料
								...newParams,
								order,
								size: params.pageSize,
								cur_page: params.current,
								custom_filter_value: params.keyword ?? "",
								custom_filter_key: custom_filter_key6,
								branchcode: select_a_library.current === "*" ? "" : select_a_library.current,
							};
							newParams = setParamsFilter({
								...newParams,
							});
							return getCirculationRulesP6Data({
								...newParams
							})
						}}
						extra_columns={extra_columns}
						set_extra_columns={set_extra_columns}
						manage_columns={true}
						rowSelection={{
							type: "checkbox",
							selectedRowKeys: selectedRowKeys6,
							selectedRowsInfo: selectedRowsInfo6,
							setSelectedRowKeys: setSelectedRowKeys6,
							setSelectedRowsInfo: setSelectedRowsInfo6,
							...rowSelection6,
						}}
						modalOpen={modalOpenP6}
						setModalOpen={setModalOpenP6}
						scroll={{
							x: "100vw"
						}}
						toolBarRender={() => toolBarRender([
						])}
						extraActionRender={(item) => {
							return (<></>)
						}}
						propsUseData={() => {
							return {
								postData: postCirculationRulesP6Data,
								patchData: patchCirculationRulesP6Data,
								deleteData: deleteCirculationRulesP6Data,
							}
						}}
						PropsPatchForm={
							<CirculationRulesP6Form
								keyPrefix={keyPrefix}
							/>
						}
						propsPatchonFinish={({ axiosMode, status }) => {
							if (status === "success") {
								actionRef6.current.reload()
							} else {

							}
						}}
						propsPatchOnBefore={() => { }}
						propsPatch
						propsPost
						propsDelete
						propsPatchProcess={(item) => {
							set_current_rule(item?.p)
							set_current_rule_data(item)
							let modal_item = {}
							for (let i = 0; i < item?.rules.length; i++) {
								modal_item[item?.rules[i].rule_name] = item?.rules[i].rule_value
							}
							modal_item["branchcode"] = item?.branchcode
							modal_item["categorycode"] = item?.categorycode
							modal_item["itemtype"] = item?.itemtype
							modal_item["current_rule_data"] = item
							return ({
								...modal_item,
							})
						}}
						propsWidth={1000}
					/>}
				</WhiteBox>}
			</Col>
		</Row >
	);
};

const WhiteBox = styled.div`
  width :auto
  background-color: #fff;
  padding: 1em;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    padding: 0.5em;
  }
`;
const Title = styled.div`
	text-align: left;
	font-size: 1.5em;
	font-weight: bold;
	margin-bottom: 1em;
`;
const Label = styled.label`
	display: block;
	margin-bottom: 8px;

	@media (max-width: 768px) {
		margin-bottom: 5px;
	}
`;
export default CirculationRules;


const useTableColumnsCheck1 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check1: check,
		custom_filter_key1: check,
		setCheck1: setCheck,
		checkAll1: checkAll,
		setOrders1: setOrders,
	};
};
const useTableColumnsCheck2 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check2: check,
		custom_filter_key2: check,
		setCheck2: setCheck,
		checkAll2: checkAll,
		setOrders2: setOrders,
	};
};
const useTableColumnsCheck3 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check3: check,
		custom_filter_key3: check,
		setCheck3: setCheck,
		checkAll3: checkAll,
		setOrders3: setOrders,
	};
};
const useTableColumnsCheck4 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check4: check,
		custom_filter_key4: check,
		setCheck4: setCheck,
		checkAll4: checkAll,
		setOrders4: setOrders,
	};
};
const useTableColumnsCheck5 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check5: check,
		custom_filter_key5: check,
		setCheck5: setCheck,
		checkAll5: checkAll,
		setOrders5: setOrders,
	};
};
const useTableColumnsCheck6 = (columns) => {
	const [check, setCheck] = useState([]);
	const checkAll = () => {
		setCheck((pre) => {
			return columns
				.filter((element) => !element.disabled)
				.map((val) => val.key);
		});
	};
	const setOrders = (sorter) => {
		let newOrders = Object.keys(sorter).map((key, index) => {
			if (sorter[key] === "descend") {
				return JSON.stringify({
					column: key,
					type: "DESC",
				});
			} else {
				return JSON.stringify({
					column: key,
					type: "ASC",
				});
			}
		});
		return newOrders;
	};
	return {
		check6: check,
		custom_filter_key6: check,
		setCheck6: setCheck,
		checkAll6: checkAll,
		setOrders6: setOrders,
	};
};